import { ContemberClientNames } from './names';
import { ContentQueryBuilder } from '@contember/client-content';
export * from './names';
export * from './enums';
export * from './entities';
export const queryBuilder = new ContentQueryBuilder(ContemberClientNames);
//# sourceMappingURL=index.js.map